/**
 * 创建一个行程的参数
 * doc: https://doc.oschina.net/xingchengzushou?t=244704
 */
import {
  EDIT_TRIP_PARAMS_CITIES,
  GET_TRIP_PARAMS_CITIES
} from '../../actionTypes';


const INIT_STATE = {
  start_date: '',
  end_date: '',
  city_day_list: [],
  create_mode: '',
  tour_grade: '',
  tour_preference: ''
};

export default function reducer(state = INIT_STATE, action) {
  if (action.type === GET_TRIP_PARAMS_CITIES
    || action.type === EDIT_TRIP_PARAMS_CITIES) {
    return action.data;
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/trip/paramsCities.js